export const MAX_NAME_LENGTH = 100;
export const MAX_EXTRACTOR_VALUE_NAME_LENGTH = 255;
export const MIN_NAME_LENGTH = 2;
// RFC 9110 token (tchar) — valid HTTP header field name characters
export const HEADER_NAME_REGEX = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+$/;
export const AUTH_TYPES = {
  KIZEN_API: 'kizen_api',
  HTTP_HEADER: 'http_header',
  BASIC_AUTH: 'basic_auth',
  NONE: 'none',
} as const;
